module.exports = __webpack_public_path__ + "img/mainRecord.9a27017a.png";